import "chart.js/auto";
import DiscountGrossPresenter from "./DiscountGrossPresenter";
import BaseListPage from "../../../base/BaseListPage";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import Export from "../../../components/Export";
import printChart from "../../../PrintChart";
import Select from "react-select";
import DefaultState from "../../sales-and-transactions/components/DefaultState";
import InitialPrompt from "../../../components/InitialPrompt";
import GrossSalesDiscountReport from "./components/DiscountReport";
import MonthSelect from "../salesDiscountAmount/components/MonthSelect";
import YearSelect from "../salesDiscountAmount/components/YearSelect";
import { exportGrossVsDiscountCSV } from "./utils/gsvCsvUtils";
import {
  getDiscountGrossChartData,
  getDiscountGrossChartOptions,
} from "./utils/discountGrossChartUtils";
import ProgressLoader from "../../../components/ProgressLoader";

class DiscountGrossPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new DiscountGrossPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      selectedStoreCode: "",
      selectedMonth: "",
      selectedYear: "",
      store: [],
      storess: "",
      range: "",
      selectedMonth: "",
      selectedMonthName: "",
      notFound: false,
    };
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
    this.handleDropdownChange = this.handleDropdownChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", "")
    );
    return [...new Set(storeCodes)];
  }

  handleDropdownChange(event) {
    const monthNames = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };
    let monthName;
    this.setState({ selectedMonth: event.target.value });

    if (event.target.value === "AllMonths") {
      this.presenter.onChangeDate("AllMonths");
    } else {
      this.setState({ range: event.target.value });
      this.presenter.onChangeDate(JSON.parse(event.target.value));
      const monthi = JSON.parse(event.target.value).$gte.split("-");
      monthName = Object.keys(monthNames).find(
        (key) => monthNames[key] === monthi[1]
      );
    }

    this.setState({ selectedMonthName: monthName });
  }

  getMonthOptions() {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months.map((month) => (
      <option key={month} value={month}>
        {month}
      </option>
    ));
  }

  months() {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const monthsFormatted = monthNames.map((name, index) => {
      const monthNumber = (index + 1).toString().padStart(2, "0");
      const firstDayOfMonth = `${this.state.selectedYear}-${monthNumber}-01T05:00:00.000Z`;

      const lastDayOfMonthDate = new Date(
        this.state.selectedYear,
        index + 1,
        0
      );
      const lastDayOfMonth = `${this.state.selectedYear}-${(
        lastDayOfMonthDate.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${lastDayOfMonthDate
        .getDate()
        .toString()
        .padStart(2, "0")}T04:59:59.999Z`;

      return {
        name,
        createdAt: {
          $gte: firstDayOfMonth,
          $lte: lastDayOfMonth,
        },
      };
    });

    return monthsFormatted;
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  handleYearChange = (event) => {
    const year = event.target.value;
    let parsedRange = JSON.parse(this.state.range);
    parsedRange.$gte =
      year + parsedRange.$gte.substring(parsedRange.$gte.indexOf("-"));
    parsedRange.$lte =
      year + parsedRange.$lte.substring(parsedRange.$lte.indexOf("-"));
    this.setState({ selectedYear: event.target.value });
    this.presenter.onChangeDate(parsedRange);
  };

  exportToCSV = () => {
    const { objects, selectedYear, selectedStoreCode } = this.state;

    exportGrossVsDiscountCSV({
      objects,
      selectedYear,
      selectedStoreCode,
      fileNamePrefix: "DiscountGross",
    });
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const {
      objects,
      selectedStoreCode,
      selectedMonthName,
      selectedYear,
      storess,
    } = this.state;
    const chartData = getDiscountGrossChartData({
      objects,
      selectedStoreCode,
      selectedMonthName,
      selectedYear,
    });
    const chartOptions = getDiscountGrossChartOptions();
    const chartId = "chart-container17";
    const storeOptions = [
      ...this.state.store.map((code) => ({
        value: code.name,
        label: code.name,
      })),
    ];
    const selectedOption = storeOptions.find(
      (opt) => opt.value === this.state.selectedStoreCode
    );

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
          <h2 className="fw-bold text-capitalize">
            <span style={{ color: "#83c14a" }}>Discount Value</span>
            <span style={{ color: "black" }}> vs.</span>
            <span style={{ color: "#c5da55" }}> Gross Sales</span>
          </h2>
          <Export
            exportCsv={this.exportToCSV}
            exportPdf={() => printChart(chartId)}
          />
        </div>

        <div className="row mb-2">
          <div className="col-sm-4">
            <Select
              options={storeOptions}
              value={selectedOption}
              onChange={(opt) => this.onChangeStore(opt.value)}
              placeholder="Select Store"
              isClearable={false}
              className="basic-single"
              classNamePrefix="select"
            />
          </div>
          <MonthSelect
            selectedMonth={this.state.selectedMonth}
            selectedMonthName={this.state.selectedMonthName}
            months={this.months.bind(this)}
            onChange={this.handleDropdownChange.bind(this)}
          />
          <YearSelect
            selectedYear={this.state.selectedYear}
            onChange={this.handleYearChange.bind(this)}
            yearsCount={3}
            className="col-sm-3"
          />
        </div>
        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 && (
          <GrossSalesDiscountReport
            chartData={chartData}
            chartOptions={chartOptions}
            storess={storess}
            containerId="chart-container17"
            chartRef={this.chartRef17}
          />
        )}

        {this.state.notFound && (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        )}

        {this.state.objects?.length === 0 &&
          this.state.storess &&
          this.state.selectedMonthName &&
          this.state.selectedYear &&
          !this.state.notFound && (
            <div className="text-center mt-5">
              <DefaultState />
            </div>
          )}

        {!this.state.storess && !this.state.selectedYear && (
          <InitialPrompt twoFilter={false} />
        )}
      </>
    );
  }
}

export default withRouter(DiscountGrossPage);
